export default {
	id: 'SIMPLE_UPGRADE_3M_44_97',
	providers: {
		stripe: '',
		braintree: '',
		paltaMap: {
			USD: 'simple_premium_3m_44_97_usd',
			EUR: 'simple_premium_3m_44_97_eur',
			GBP: 'simple_premium_3m_44_97_gbp',
			AUD: 'simple_premium_3m_65_aud',
			CAD: 'simple_premium_3m_65_cad',
			SEK: 'simple_premium_3m_529_sek',
			BRL: 'simple_premium_3m_143_20_brl',
			DKK: 'simple_premium_3m_329_dkk',
			NOK: 'simple_premium_3m_529_nok',
			MXN: 'simple_premium_3m_759_mxn',
			TRY: 'simple_premium_3m_1499_try',
			ARS: 'simple_premium_3m_59970_ars',
			COP: 'simple_premium_3m_182490_cop',
			CLP: 'simple_premium_3m_43650_clp',
		},
		primer: 'prd_HnTjKZ24r36r',
	},
	model: {
		commitment_period: 0,
		intro_period_value: 3,
		intro_period_type: 'month',
		next_period_value: 3,
		next_period_type: 'month',
	},
	trial: null,
	subscription: {
		interval: 'month',
		intervalCount: 3,
		priceMap: {
			USD: 44.97,
			EUR: 44.97,
			GBP: 44.97,
			AUD: 65,
			CAD: 65,
			SEK: 529,
			BRL: 143.2,
			DKK: 329,
			NOK: 529,
			MXN: 759,
			TRY: 1499,
			ARS: 59970,
			COP: 182490,
			CLP: 43650,
		},
	},
	options: ($t) => ({
		barChartTooltip: $t('activity_upgrade.3mo.bar_chart_tooltip'),
		barChartLeftLabel: $t('activity_upgrade.3mo.bar_chart_left_label'),
		barChartRightLabel: $t('activity_upgrade.3mo.bar_chart_right_label'),
	}),
}
